import {ILanguageSwitcherItem} from './language-switcher-item.interface';

export class SelectedLanguageSwitcherItem implements ILanguageSwitcherItem {
  constructor(private _title: string) {

  }
  get isCurrent(): boolean {
    return true;
  }
  get title(): string {
    return this._title;
  }

  get url(): string {
    return '';
  }

  makeCurrent(): void {
  }

}
